//import firebase from 'firebase'
import React from 'react'
import {connect} from "react-redux"
import {withRouter} from 'react-router'
import VideoPageContent from './VideoPageContent'
import { setTitle, fetchVideos } from "../../actions"

@connect((store) => {
	return {
		User: store.User.User,
		videos: store.videos
	}
})
class VideoPage extends React.Component {
	constructor(props){
		super(props)
		this.video = this.video.bind(this)
	}
  componentWillMount(){
		const { dispatch } = this.props;
		dispatch(fetchVideos());

    dispatch(setTitle(`${this.video().name}`));
  }
	video(){
		const { videos, params } = this.props
		return videos[params.id] || {}
	}

	render() {
		return <VideoPageContent video={this.video()} />
	}
}

export default withRouter(VideoPage);



// WEBPACK FOOTER //
// ./src/components/home/VideoPage.jsx